<script setup>
import Error from '@/assets/icons/error.svg'
import Success from '@/assets/icons/success.svg'

const props = defineProps({
    msgConfig: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                message: value => value.message === undefined || typeof value.message === 'string',
                error: value => value.error === undefined || typeof value.error === 'boolean',
                success: value => value.success === undefined || typeof value.success === 'boolean'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

const formInputClass = computed(() => {
    return {
        'form-error-message': props?.msgConfig?.error,
        'form-success-message': props?.msgConfig?.success
    }
})
</script>

<template>
    <span v-if="(msgConfig.error || msgConfig.success) && msgConfig.message" :class="formInputClass">
        <component :is="msgConfig.error ? Error : Success" />
        {{ msgConfig.message }}
    </span>
</template>

<style lang="scss">
.form-error-message {
    @include form-input-message($type: 'error');
}

.form-success-message {
    @include form-input-message($type: 'success');
}
</style>
